export function getApiOrigin() {
  const rawValue = String(process.env.VUE_APP_API_BASE_URL || '').trim()
  if (!rawValue) {
    return ''
  }

  return rawValue.replace(/\/+$/, '').replace(/\/api$/i, '')
}

export function buildApiUrl(path) {
  const normalizedPath = String(path || '')
  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath
  }

  const prefixedPath = normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`
  return `${getApiOrigin()}${prefixedPath}`
}
